import React from "react";
import PropTypes from "prop-types";

import * as Icons from 'components/icons';


// StyleGuide = elements/icons/*

const SVGIcon = ({ className = "", name, ...iconProps }) => {
  const Icon = Icons[name];
  if (!Icon) {
    console.warn(`Invalid SVGIcon name "${name}"`);
    return null;
  }
  return <Icon className={className} {...iconProps} />;
};

SVGIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.oneOf(Object.keys(Icons)).isRequired
};

export default SVGIcon;
